import { useEffect } from "react";
import usePrevious from "../../../hooks/usePrevious";
export function useAutofocus(enabled, ref, feature, onAutoFocus) {
    const previousFeature = usePrevious(feature);
    const previousRef = usePrevious(ref.current);
    useEffect(() => {
        if (!enabled || !feature || !ref.current) {
            return;
        }
        // Autofocus on mount or if feature is selected
        if (feature &&
            (ref.current !== previousRef || feature !== previousFeature)) {
            console.log("@mapsight/ui: FSI Wrapper autofocus");
            //ref.current.scrollIntoView({block: 'start', behavior: 'smooth'});
            ref.current.focus({ preventScroll: true });
            if (onAutoFocus) {
                onAutoFocus();
            }
        }
    }, [enabled, feature, onAutoFocus, previousFeature, previousRef, ref]);
}
